export class Mediafile {
    constructor(id, type, isFolder) {
        this.id = id;
        this.type = type;
        this.isFolder = isFolder;
    }
    copy() {
        return new Mediafile(this.id, this.type, this.isFolder);
    }
    calculateSize(files) {
        return files.reduce((a, f) => {
            if(!this.isFolder && (f.id == this.id)) {
                return a + 1;
            } else if(this.isFolder && (f.folder == this.id) && (f.filetype == this.type)) {
                return a + 1;
            }
            return a;
        }, 0)
    }
    calculateDuration(files) {
        return files.reduce((a, f) => {
            if(!this.isFolder && (f.id == this.id)) {
                return a + f.duration;
            } else if(this.isFolder && (f.folder == this.id) && (f.filetype == this.type)) {
                return a + f.duration;
            }
            return a;
        }, 0)
    }
    export(){
        return {
            id: this.id,
            folder: this.isFolder
        }
    }
}

export class DailyTime {
    constructor(hour, minutes) {
        this.label = 'Каждый день';
        this.hour = hour;
        this.minutes = minutes;
    }

    copy() {
        return new DailyTime(this.hour, this.minutes);
    }

    toString() {
        return (this.hour < 10 ? '0' + this.hour : this.hour) + ':' + (this.minutes < 10 ? '0' + this.minutes : this.minutes)
    }

    export(){
        return {
            hour: this.hour.toString(),
            minute: this.minutes.toString()
        }
    }
}

export class PeriodicTime {
    constructor(start, repeat, duration) {
        this.label = `Каждые ${repeat} минут`;
        this.start = start;
        this.repeat = repeat;
        this.duration = duration;
    }

    copy() {
        return new PeriodicTime(this.start, this.repeat, this.duration);
    }

    export(){
        return {
            start: this.start.export(),
            repeat: this.repeat,
            duration: this.duration,
        }
    }
}
// export class HalfHourlyTime {
//     constructor(start, repeat, duration) {
//         this.label = 'Каждые полчаса';
//         this.start = start;
//         this.repeat = repeat;
//         this.duration = duration;
//     }

//     copy() {
//         return new HalfHourlyTime(this.start, this.duration, this.repeat);
//     }

//     export(){
//         return {
//             start:[this.start.export()],
//             repeat: this.repeat.toString(),
//             duration: this.duration.toString(),
//         }
//     }
// }
// export class QuarterHourlyTime {
//     constructor(start, repeat, duration) {
//         this.label = 'Каждые 15 минут';
//         this.start = start;
//         this.repeat = repeat;
//         this.duration = duration;
//     }

//     copy() {
//         return new QuarterHourlyTime(this.start, this.duration, this.repeat);
//     }

//     export(){
//         return {
//             start:[this.start.export()],
//             repeat: this.repeat.toString(),
//             duration: this.duration.toString(),
//         }
//     }
// }
// export class SixthHourlyTime {
//     constructor(start, repeat, duration) {
//         this.label = 'Каждые 10 минут';
//         this.start = start;
//         this.repeat = repeat;
//         this.duration = duration;
//     }

//     copy() {
//         return new SixthHourlyTime(this.start, this.duration, this.repeat);
//     }

//     export(){
//         return {
//             start:[this.start.export()],
//             repeat: this.repeat.toString(),
//             duration: this.duration.toString(),
//         }
//     }
// }
// export class TwelfthHourlyTime {
//     constructor(start, repeat, duration) {
//         this.label = 'Каждые 5 минут';
//         this.start = start;
//         this.repeat = repeat;
//         this.duration = duration;
//     }

//     copy() {
//         return new TwelfthHourlyTime(this.start, this.duration, this.repeat);
//     }

//     export(){
//         return {
//             start:[this.start.export()],
//             repeat: this.repeat.toString(),
//             duration: this.duration.toString(),
//         }
//     }
// }
// export class HourlyTime {
//     constructor(minutes) {
//         this.label = 'Каждый час';
//         this.minutes = minutes;
//     }

//     copy(){
//         return new HourlyTime(this.minutes);
//     }

//     toString() {
//         return this.minutes.toString();
//     }

//     export(){
//         return {
//             hour: '*',
//             minute: this.minutes.toString()
//         }
//     }
// }
// export class HalfHourlyTime {
//     constructor(minutes) {
//         this.label = 'Каждые 30 минут';
//         this.minutes = minutes;
//     }

//     copy(){
//         return new HalfHourlyTime(this.minutes);
//     }

//     toString() {
//         return this.minutes.toString();
//     }

//     export(){
//         return {
//             hour: '*/30',
//             minute: this.minutes.toString()
//         }
//     }
// }
// export class QuarterHourlyTime {
//     constructor(minutes) {
//         this.label = 'Каждые 15 минут';
//         this.minutes = minutes;
//     }

//     copy(){
//         return new QuarterHourlyTime(this.minutes);
//     }

//     toString() {
//         return this.minutes.toString();
//     }

//     export(){
//         return {
//             hour: '*/15',
//             minute: this.minutes.toString()
//         }
//     }
// }
// export class SixthPartHourlyTime {
//     constructor(minutes) {
//         this.label = 'Каждые 10 минут';
//         this.minutes = minutes;
//     }

//     copy(){
//         return new SixthPartHourlyTime(this.minutes);
//     }

//     toString() {
//         return this.minutes.toString();
//     }

//     export(){
//         return {
//             hour: '*/10',
//             minute: this.minutes.toString()
//         }
//     }
// }
// export class TwelfthPartHourlyTime {
//     constructor(minutes) {
//         this.label = 'Каждые 5 минут';
//         this.minutes = minutes;
//     }

//     copy(){
//         return new TwelfthPartHourlyTime(this.minutes);
//     }

//     toString() {
//         return this.minutes.toString();
//     }

//     export(){
//         return {
//             hour: '*/5',
//             minute: this.minutes.toString()
//         }
//     }
// }
// export class SpecificTime {
//     constructor(minutes) {
//         this.label = 'Каждые 15 минут';
//         this.minutes = minutes;
//     }
//
//     copy(){
//         return new HourlyTime(this.minutes);
//     }
//
//     toString() {
//         return this.minutes.toString();
//     }
//
//     export(){
//         return {
//             hour: '*/15',
//             minute: this.minutes.toString()
//         }
//     }
// }
export class ScheduleBehavior {

}

export class DefaultSchedule extends ScheduleBehavior {
    constructor() {
        super()
        this.label = 'По умолчанию';
    }

    copy() {
        return new DefaultSchedule();
    }

    toString() {
        return 'Задача по умолчанию';
    }
    
    export(){
        return null;
    }
}

export class PlayUntilCompleted extends ScheduleBehavior {
    constructor(start) {
        super()
        this.label = 'Проиграть до конца';
        this.start = start;
    }

    copy() {
        return new PlayUntilCompleted(this.start.copy());
    }

    toString(){
        if(this.start instanceof DailyTime){
            return `В ${this.start.toString()}`
        } else if(this.start instanceof PeriodicTime) {
            return `В ${this.start.toString()} минут каждый час`
        }
    }

    export(){
        return [this.start.export()]
    }
}

export class PlayUntilTime extends ScheduleBehavior {
    constructor(start, end) {
        super()
        this.label = 'Повторять';
        this.start = start;
        this.end = end;
    }

    copy() {
        return new PlayUntilTime(this.start.copy(), this.end.copy());
    }

    toString(){
        if(this.start instanceof DailyTime){
            return `С ${this.start.toString()} до ${this.end.toString()}`
        } else if(this.start instanceof PeriodicTime) {
            return `С ${this.start.toString()} по ${this.end.toString()} минуту каждый час`
        }
    }

    export(){
        return [this.start.export(), this.end.export()]
    }
}

export class Task {
    constructor(taskSchedule,taskName,color) {
        this.schedule = taskSchedule;
        this.taskName = taskName;
        this.color = color;
    }
}

export class SleepTask extends Task {
    constructor(schedule,taskName, color) {
        super(schedule,taskName, color)
        this.label = 'Спящий режим';
        this.taskName = taskName;
        this.color = color;
    }
    copy() {
        return new SleepTask(this.schedule.copy(),this.taskName,this.color);
    }
    export(){
        return {
            method: 'sleep',
            resource: null,
            schedule: this.schedule.export(),
            taskName: this.taskName,
            color:this.color
        }
    }
}

export class PlaylistTask extends Task {
    constructor(playlist, schedule,taskName,color) {
        super(schedule,taskName,color);
        this.playlist = playlist;
        this.taskName = taskName;
        this.color = color;
    }
    calculateSize(files) {
        return this.playlist.reduce((sum, item) => {
            return sum + item.calculateSize(files);
        }, 0);
    }
    calculateDuration(files) {

    }
    add(file) {
        this.playlist.push(file);
    }
    remove(file) {
        this.playlist = this.playlist.filter((f) => {
            return f.id != file.id;
        });
    }
    insertBeforeIndex(file, index) {
        this.playlist.splice(index, 0, file);
    }
    move(oldIndex, newIndex) {
        // TODO: check bounds
        let file = this.playlist.splice(oldIndex, 1)[0];
        if(newIndex > oldIndex) newIndex - 1;
        this.playlist.splice(newIndex, 0, file);
    }
    moveUp(index) {
        if((index < 1) && (index >= this.playlist.length))
            throw Error('Unreachable playlist item');
        let t = this.playlist[index];
        this.playlist[index] = this.playlist[index - 1];
        this.playlist[index - 1] = t;
    }
    moveDown(index) {
        if((index < 0) && (index >= this.playlist.length - 1))
            throw Error('Unreachable playlist item');
        let t = this.playlist[index];
        this.playlist[index] = this.playlist[index + 1];
        this.playlist[index + 1] = t;
    }
    removeByIndex(index) {
        if((index < 0) && (index >= this.playlist.length))
            throw Error('Unreachable playlist item');
        this.playlist.splice(index, 1);
    }
}

export class URLTask extends Task {
    constructor(url, schedule,taskName,color) {
        super(schedule,taskName,);
        this.url = url;
        this.taskName = taskName;
        this.color = color;
    }
}

export class VideoTask extends PlaylistTask {
    constructor(playlist, schedule,taskName,color) {
        super(playlist, schedule,taskName,color);
        this.taskName = taskName;
        this.acceptedType = 'video';
        this.label = 'Видео';
        this.color = color;
    }
    copy(){
        return new VideoTask(
            this.playlist.map(it => it.copy()),
            this.schedule.copy(),
            this.taskName,
            this.color
        );
    }
    calculateDuration(files){
        return this.playlist.reduce((sum, item) => {
            return sum + item.calculateDuration(files);
        }, 0);
    }
    export(){
        return {
            method: 'play',
            resource: this.playlist.map((f) => {
                return f.export()
            }),
            schedule: this.schedule.export(),
            taskName: this.taskName,
            color:this.color
        }
    }
}

export class DocumentTask extends PlaylistTask {
    constructor(playlist, schedule, taskName,color,delay,) {
        super(playlist, schedule,taskName,color);
        this.acceptedType = 'document';
        this.label = 'Документы';
        this.delay = delay;
        this.taskName=taskName;
        this.color=color;
    }
    calculateDuration(files){
        return this.playlist.reduce((sum, item) => {
            return sum + item.calculateDuration(files);
        }, 0) * this.delay;
    }
    copy(){
        return new DocumentTask(
            this.playlist.map(it => it.copy()),
            this.schedule.copy(),
            this.taskName,
            this.color,
            this.delay,
        );
    }
    export(){
        return {
            method: 'doc',
            delay: this.delay,
            resource: this.playlist.map((f) => {
                return f.export()
            }),
            schedule: this.schedule.export(),
            taskName: this.taskName,
            color: this.color
        }
    }
}

export class SlideshowTask extends PlaylistTask {
    constructor(videos, schedule, taskName,color,delay) {
        super(videos, schedule,taskName);
        this.label = 'Изображения';
        this.acceptedType = 'image';
        this.delay = delay;
        this.taskName = taskName;
        this.color = color;
    }
    
    calculateDuration(files){
        return this.calculateSize(files) * this.delay;
    }
    copy(){
        return new SlideshowTask(
            this.playlist.map(it => it.copy()),
            this.schedule.copy(),
            this.taskName,
            this.color,
            this.delay,
        );
    }
    export(){
        return {
            method: 'slideshow',
            delay: this.delay,
            resource: this.playlist.map((f) => {
                return f.export()
            }),
            schedule: this.schedule.export(),
            taskName: this.taskName,
            color:this.color
        }
    }
}

export class StreamTask extends URLTask {
    constructor(url, schedule,taskName,color) {
        super(url, schedule,taskName,color);
        this.label = 'Трансляция';
        this.taskName = taskName;
        this.color = color;
    }
    copy() {
        return new StreamTask(this.url, this.schedule.copy(),this.taskName,this.color);
    }
    export(){
        return {
            method: 'stream',
            resource: this.url,
            schedule: this.schedule.export(),
            taskName: this.taskName,
            color:this.color
        }
    }
}

export class WebTask extends URLTask {
    constructor(url, schedule,taskName,color) {
        super(url, schedule,taskName,color);
        this.label = 'Web-страница';
        this.taskName = taskName;
        this.color  = color;
    }
    copy() {
        return new WebTask(this.url, this.schedule.copy(),this.taskName, this.color);
    }
    export(){
        return {
            method: 'web',
            resource: this.url,
            schedule: this.schedule.export(),
            taskName: this.taskName,
            color: this.color
        }
    }
}

export class Schedule {
    constructor() {
        this.tasks = [];
        this.lastTaskKey = 0;
        this.hasDefaultTask = false;
    }
    getTaskKey() {
        let key = this.lastTaskKey;
        this.lastTaskKey++;
        return key;
    }
    addTask(task) {
        task.key = this.getTaskKey();

        if(task.schedule instanceof DefaultSchedule){
            if(this.hasDefaultTask)
                throw Error('Schedule has default task already');
            this.hasDefaultTask = true;
            this.tasks.unshift(task);
            return 0;
        }
        this.tasks.push(task);
        return this.tasks.length - 1;
    }
    increaseTaskPriority(index) {
        if(index < (this.tasks.length - 1)) {
            let task = this.tasks[index];
            this.tasks[index] = this.tasks[index + 1];
            this.tasks[index + 1] = task;
        }
    }
    decreaseTaskPriority(index) {
        if(index > 1) {
            let task = this.tasks[index];
            this.tasks[index] = this.tasks[index - 1];
            this.tasks[index - 1] = task;
        }
    }
    updateTask(index, task) {
        // TODO: move down if become default
        const wasDefault = this.tasks[index].schedule instanceof DefaultSchedule
        task.key = this.tasks[index].key; // NOTE: copy task key
        if(task.schedule instanceof DefaultSchedule){
            if(!wasDefault) {
                if(this.hasDefaultTask) {
                    throw Error('Schedule has default task already');
                }
                this.tasks.splice(index, 1);
                this.tasks.unshift(task);
                this.hasDefaultTask = true;
                return
            }
            this.hasDefaultTask = true;
        } else if(wasDefault) {
            this.hasDefaultTask = false;
        }
        this.tasks[index] = task;
    }
    removeTask(task) {
        if(task.schedule instanceof DefaultSchedule){
            this.hasDefaultTask = false;
        }
        this.tasks = this.tasks.filter((t) => { return t != task });
    }
    export() {
        return this.tasks.map((t) => { return t.export(); })
    }
    parseTime(time) {
        if(time.hour == '*'){
            return new PeriodicTime(parseInt(time.minute))
        } else if(time.hour == '*/30') {
            return new PeriodicTime(parseInt(time.minute))
        } else if(time.hour == '*/15'){
            return new PeriodicTime(parseInt(time.minute))
        }else if(time.hour == '*/10'){
            return new PeriodicTime(parseInt(time.minute))
        }else if(time.hour == '*/5'){
            return new PeriodicTime(parseInt(time.minute))
        }
        else {
            return new DailyTime(parseInt(time.hour), parseInt(time.minute))
        }
    }
    parseTaskSchedule(schedule) {
        if(schedule == null){
            return new DefaultSchedule();
        } else if(schedule.length == 1){
            return new PlayUntilCompleted(
                this.parseTime(schedule[0])
            )
        } else if(schedule.length == 2){
            return new PlayUntilTime(
                this.parseTime(schedule[0]),
                this.parseTime(schedule[1])
            )
        } else if(typeof schedule == 'object'){
            return new PeriodicTime(
                this.parseTime(schedule.start),
                schedule.repeat,
                schedule.duration
                
            )
        }
    }
    copy() {
        let schedule = new Schedule();
        schedule.hasDefaultTask = this.hasDefaultTask;
        schedule.tasks = this.tasks.map(it => it.copy());
        return schedule;
    }
    import(tasks){
        this.lastTaskKey = 0;
        let parsedTasks = tasks.map((t) => {
            let schedule = this.parseTaskSchedule(t.schedule);
            if(schedule instanceof DefaultSchedule)
                this.hasDefaultTask = true;
            // TODO: inject mediafile data from files
            // TODO: add type to mediafiles/folders
            switch(t.method){
                case 'play':
                    return new VideoTask(
                        t.resource.map((r) => {
                            return new Mediafile(r.id, 'video', r.folder)
                        }),
                        schedule,
                        t.taskName,
                        t.color
                    )
                case 'doc':
                    return new DocumentTask(
                        t.resource.map((r) => {
                            return new Mediafile(r.id, 'document', r.folder)
                        }),
                        schedule,
                        t.taskName,
                        t.color,
                        t.delay,
                    )
                case 'slideshow':
                    return new SlideshowTask(
                        t.resource.map((r) => {
                            return new Mediafile(r.id, 'image', r.folder)
                        }),
                        schedule,
                        t.taskName,
                        t.color,
                        t.delay,
                    )
                case 'stream':
                    return new StreamTask(
                        t.resource,
                        schedule,
                        t.taskName,
                        t.color
                    )
                case 'web':
                    return new WebTask(
                        t.resource,
                        schedule,
                        t.taskName,
                        t.color
                    )
                case 'sleep':
                    return new SleepTask(schedule,t.taskName, t.color);
                default:
                    throw Error('Unknown task type');
            }
        });
        /* move default task to first item */
        for(let i = 0; i < parsedTasks.length; i++) {
            if((parsedTasks[i].schedule instanceof DefaultSchedule) && (i > 0)){
                let task = parsedTasks.splice(i, 1)[0];
                parsedTasks.unshift(task);
                break;
            }
        }
        this.tasks = parsedTasks.map((task) => {
            task.key = this.getTaskKey();
            return task;
        });
    }
}
